import React, { Component, createRef } from 'react';
import { NavLink, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { startFetch, endFetch } from '../../../actions/generalActions';
import { ChevronLeft, ChevronRight } from '../normalizer';

class SupportingDocumentsNavbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
      supportingDocuments: [],
      canScrollLeft: false,
      canScrollRight: false,
    };
    this.trackRef = createRef();
  }

  componentDidMount() {
    if (this.props.supportingDocuments.length > 0) {
      this.redirectToFirstDocumentIfNeeded();
    }
    this.checkScrollButtons();
    window.addEventListener('resize', this.checkScrollButtons);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.supportingDocuments !== this.props.supportingDocuments) {
      this.checkScrollButtons();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkScrollButtons);
  }

  redirectToFirstDocumentIfNeeded = () => {
    const { supportingDocuments, history } = this.props;
    if (supportingDocuments.length > 0) {
      history.push('/supporting-documents/' + supportingDocuments[0].id);
    }
  }

  checkScrollButtons = () => {
    const el = this.trackRef.current;
    if (!el) return;
    this.setState({
      canScrollLeft: el.scrollLeft > 0,
      canScrollRight: el.scrollLeft + el.clientWidth < el.scrollWidth - 1,
    });
  }

  scrollLeft = () => {
    const el = this.trackRef.current;
    if (el) el.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight = () => {
    const el = this.trackRef.current;
    if (el) el.scrollBy({ left: 200, behavior: 'smooth' });
  }

  render() {
    const colors = this.props.campaign.template && this.props.campaign.template.appearence && this.props.campaign.template.appearence.colors;
    const activeStyle = { backgroundColor: colors && colors["brand-default"] };
    const { supportingDocuments } = this.props;
    const { canScrollLeft, canScrollRight } = this.state;

    return (
      <div className="document-navbar">
        {canScrollLeft && (
          <button
            type="button"
            className="document-navbar__scroll-btn document-navbar__scroll-btn--left"
            onClick={this.scrollLeft}
            aria-label="Anterior"
          >
            <ChevronLeft />
          </button>
        )}
        <div
          className="document-navbar__track"
          ref={this.trackRef}
          onScroll={this.checkScrollButtons}
        >
          {supportingDocuments.map((item, i) => (
            <NavLink
              key={i}
              id={'supporting-documents-' + item.id}
              to={'/supporting-documents/' + item.id}
              className="document-navbar-tab"
              activeClassName="document-navbar-tab-active"
              activeStyle={activeStyle}
            >
              <div className="document-navbar-tab-text">{item.name}</div>
            </NavLink>
          ))}
        </div>
        {canScrollRight && (
          <button
            type="button"
            className="document-navbar__scroll-btn document-navbar__scroll-btn--right"
            onClick={this.scrollRight}
            aria-label="Próximo"
          >
            <ChevronRight />
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    supportingDocuments: state.supportingDocumentsReducer.supportingDocuments
  }
}

function mapDispatchToProps(dispatch){
    return{
      startFetch: () => { dispatch(startFetch())},
      endFetch: () => { dispatch(endFetch())},
    }
  }
  

  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupportingDocumentsNavbar));
  